import Select, { MultiValue } from 'react-select';
import React, { useEffect, useState } from 'react';
import { sortFilterOptions } from 'features/gridReport/functions/sortFilterOptions';
import './FilterSelect.css';
import { processMultiSelectValues } from './functions/processMultiSelectValues';

interface FilterMultiSelectProps {
  name: string;
  label: string;
  value?: string | string[];
  options: string[];
  onChange?: (name: string, value: any) => void;
}

// Define the type for our options
type OptionType = {
  value: string;
  label: string;
};

export const FilterMultiSelect: React.FC<FilterMultiSelectProps> = ({
  name,
  label,
  value,
  options,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] =
    useState<MultiValue<OptionType> | null>(null);

  // Handler for when selection changes
  const handleChange = (selected: MultiValue<OptionType> | null) => {
    setSelectedOption(selected);
    onChange &&
      onChange(name, selected ? selected.map(item => item.value) : []);
  };

  // Convert string array to the format required by react-select
  const optionsMap: OptionType[] = sortFilterOptions(options).map(item => ({
    value: item,
    label: item,
  }));

  useEffect(() => {
    if (!value) {
      setSelectedOption(null);
      return;
    }

    const selectedValues = processMultiSelectValues(value);

    setSelectedOption(selectedValues);
  }, [value]);

  return (
    <div>
      <label className="slicer-label">{label}</label>
      <Select
        isSearchable
        isClearable
        options={optionsMap}
        name="label"
        isMulti
        value={selectedOption}
        onChange={handleChange}
        className="basic-single"
        placeholder="Select..."
      />
    </div>
  );
};
